<div class="table-container surface-card">
  <div class="top-action-button">
    <div
      *ngIf="tableConfig.exportable"
      class="export-table"
      [ngStyle]="tableConfig.exportable.position"
    >
      <app-base-button
        [actionType]="ACTION_PERMISSION.EXPORT"
        label="Export"
        type="split"
        iconName="pi pi-upload"
        [outlined]="true"
        [splitButtonItems]="exportTableType"
        [splitOneClick]="true"
        [moduleCode]="moduleCode"
      ></app-base-button>
    </div>

    <div
      *ngIf="tableConfig.inBulkable"
      class="export-table"
      [ngStyle]="tableConfig.inBulkable.position"
    >
      <app-base-button
        label="Create in Bulk"
        type="split"
        [outlined]="true"
        [splitButtonItems]="tableConfig.inBulkOption"
        [splitOneClick]="true"
        [moduleCode]="moduleCode"
        (onClick)="handleOnInBulk($event)"
        [actionType]="ACTION_PERMISSION.CREATE"
      ></app-base-button>
    </div>

    <div
      *ngIf="tableConfig.importable"
      class="import-table"
      [ngStyle]="tableConfig.importable.position"
    >
      <app-base-button
        label="Import"
        iconName="pi pi-download"
        [outlined]="true"
        (onClick)="handleImport()"
        [actionType]="ACTION_PERMISSION.IMPORT"
      ></app-base-button>
    </div>
  </div>

  <div
    *ngIf="tableConfig.topButtons"
    class="top-buttons flex align-items-center justify-content-end gap-3"
    [ngStyle]="tableConfig.topButtons.position"
  >
    <app-base-button
      *ngFor="let button of tableConfig.topButtons.buttons"
      [label]="button.label"
      [iconName]="button.icon || ''"
      [outlined]="button.outlined"
      (onClick)="button?.onClick($event)"
      [actionType]="button.actionPermission?.actionType"
      [moduleCode]="button.actionPermission?.moduleCode"
      [createdBy]="button.actionPermission?.createdBy"
    ></app-base-button>
  </div>

  <div
    class="flex w-full mb-3 pt-3 justify-content-between align-items-center px-4"
    *ngIf="tableConfig.toolbarConfig?.display && selectedRows.length > 0"
  >
    <div>
      <label class="text-lg font-normal text-900">
        {{ selectedRows.length }} selected
      </label>
    </div>

    <div class="flex">
      <app-base-button
        label="Clear Selection"
        class="mr-4"
        [outlined]="true"
        (onClick)="onRowUnselectAll()"
        [rightIcon]="true"
        [iconName]="'pi pi-times'"
      >
      </app-base-button>
      <app-base-button
        *ngIf="tableConfig.toolbarConfig?.actionList"
        [label]="'ACTIONS'"
        type="split"
        [splitOneClick]="true"
        [disabled]="!selectedRows || !selectedRows.length"
        [ngClass]="'border-none'"
        [splitButtonItems]="
          tableConfig.toolbarConfig?.actionList?.splitButtonItems || []
        "
        [actionType]="tableConfig.toolbarConfig?.actionList?.actionType"
      >
      </app-base-button>
      <ng-template
        [ngIf]="!!tableConfig.toolbarConfig?.multipleDelete"
        [permissionType]="ACTION_PERMISSION.DELETE"
      >
        <app-base-button
          [label]="'DELETE'"
          iconName="pi pi-trash"
          [color]="'red'"
          [disabled]="!selectedRows || !selectedRows.length"
          [ngClass]="'border-none'"
          (onClick)="deleteMultiple()"
        >
        </app-base-button>
      </ng-template>

      <app-base-button
        *ngIf="tableConfig.toolbarConfig?.multipleDownload"
        label="DOWNLOAD"
        [disabled]="!selectedRows || !selectedRows.length"
        (onClick)="multipleDownload()"
      >
      </app-base-button>
    </div>
  </div>
  <p-table
    [value]="dataTable"
    responsiveLayout="scroll"
    (onRowSelect)="onRowSelect($event)"
    (onRowUnselect)="onRowUnselect($event)"
    [dataKey]="tableConfig.dataKey"
    [paginator]="checkPaginator()"
    [rowsPerPageOptions]="[5, 10, 15, 25, 50]"
    [lazy]="true"
    (onLazyLoad)="handleLazyLoad($event)"
    [(selection)]="selectedRows"
    [totalRecords]="totalRecords"
    (onHeaderCheckboxToggle)="onRowSelectAll($event)"
    #table
    [rows]="rows"
    [first]="first"
    editMode="row"
    sortMode="multiple"
    [multiSortMeta]="defaultSort"
    paginatorDropdownAppendTo="body"
    [ngClass]="{ 'table-border': border }"
    [rowSelectable]="isRowSelectable"
    [scrollable]="tableOptions?.scrollable"
    [scrollHeight]="tableOptions?.scrollHeight"
  >
    <ng-template pTemplate="header">
      <tr>
        <th *ngIf="tableConfig.selectable" class="w-1rem">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th
          *ngFor="let item of tableConfig.columnsConfig"
          [style.width.%]="item.colSpan"
          [pSortableColumn]="
            item.sortable
              ? item.sortField
                ? $any(item).sortField
                : item.dataField
              : ''
          "
          [pSortableColumnDisabled]="item.sortable ? false : true"
          [class]="item.cssTitle"
        >
          <div class="flex align-items-center">
            <div>
              {{ $any(item).columnName | translate }}
              <span class="font-medium" *ngIf="item.headerCurrency">
                ({{ item.headerCurrency }})</span
              >
              <div class="sub-col-name" *ngIf="item.subColumnName">
                {{ item.subColumnName | translate }}
              </div>
            </div>

            <p-sortIcon
              *ngIf="item.sortable"
              [field]="
                item.sortField ? $any(item).sortField : $any(item).dataField
              "
            ></p-sortIcon>
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-rowIndex="rowIndex"
      let-data
      let-editing="editing"
    >
      <tr [pEditableRow]="data">
        <td *ngIf="tableConfig.selectable">
          <p-tableCheckbox
            *ngIf="!editing"
            [disabled]="
              tableConfig.isRowSelectable ? isDisabledRowCheckbox(data) : false
            "
            [value]="data"
          ></p-tableCheckbox>
        </td>
        <td
          *ngFor="let item of tableConfig.columnsConfig"
          [ngClass]="{ 'edit-row': editing }"
        >
          <p-cellEditor>
            <!-- EDIT  -->

            <ng-template pTemplate="input">
              <!-- <div *ngIf="!checkActionType(item.type); else confirm_content">
                <app-base-form *ngIf="item.editConfig" [formConfig]="getEditConfig(item, rowIndex)"></app-base-form>
              </div> -->
              <ng-template #confirm_content>
                <div class="flex"></div>
              </ng-template>
            </ng-template>

            <!-- DISLAY  -->

            <ng-template pTemplate="output">
              <div
                [ngSwitch]="item.type"
                [className]="item.cssContainer"
                [ngClass]="{
                  'cursor-pointer text-primary font-medium':
                    item.onClick && checkPermission(item, data),
                  'text-cell': !checkActionType(item.type)
                }"
                (click)="
                  checkPermission(item, data) &&
                    handleClickCell($event, item, data)
                "
              >
                <div
                  *ngSwitchCase="COLUMN_TYPE.Index"
                  [class]="getStatusClassWrapper(item, data)"
                >
                  {{ rowIndex + 1 }}
                </div>
                <div
                  *ngSwitchCase="COLUMN_TYPE.CheckBox"
                  [class]="getStatusClassWrapper(item, data)"
                >
                  <p-checkbox
                    [disabled]="$any(item).disabled"
                    [ngModel]="!!data[item.dataField]"
                    [binary]="true"
                  ></p-checkbox>
                </div>
                <div
                  *ngSwitchCase="COLUMN_TYPE.Textbox"
                  [class]="getStatusClassWrapper(item, data)"
                >
                  <app-base-input
                    [fieldControl]="
                      getFieldControlDisplay(rowIndex, item.dataField)
                    "
                    [disabled]="getDisabledControlCell(item, data)"
                    [errorMessageList]="$any(item).errorMessageList"
                  >
                  </app-base-input>
                </div>

                <div
                  *ngSwitchCase="COLUMN_TYPE.ToggleButton"
                  [class]="getStatusClassWrapper(item, data)"
                >
                  <p-inputSwitch
                    [(ngModel)]="data[item.dataField ?? '']"
                  ></p-inputSwitch>
                </div>

                <div
                  *ngSwitchCase="COLUMN_TYPE.InputNumber"
                  [class]="getStatusClassWrapper(item, data)"
                >
                  <app-base-input
                    [fieldControl]="
                      getFieldControlDisplay(rowIndex, item.dataField)
                    "
                    [disabled]="getDisabledControlCell(item, data)"
                    [errorMessageList]="$any(item).errorMessageList"
                    mode="number"
                    [min]="$any(item).min"
                    [max]="$any(item).max"
                    [minFractionDigits]="$any(item).minFractionDigits"
                    [maxFractionDigits]="$any(item).maxFractionDigits"
                    [maxLength]="$any(item).maxLength"
                  >
                  </app-base-input>
                </div>
                <div
                  *ngSwitchCase="COLUMN_TYPE.Dropdown"
                  [class]="getStatusClassWrapper(item, data)"
                >
                  <ng-container *ngIf="editInline">
                    <app-base-dropdown
                      [fieldControl]="
                        getFieldControlDisplay(rowIndex, item.dataField)
                      "
                      [disabled]="getDisabledControlCell(item, data)"
                      [options]="$any(item).options"
                      [searchable]="$any(item).searchable"
                      [virtualScroll]="$any(item).virtualScroll"
                      [dataSourceAction]="$any(item).dataSourceAction"
                      [errorMessageList]="$any(item).errorMessageList"
                      (onItemSelected)="
                        $any(item).onSelected
                          ? $any(item).onSelected($event, rowIndex, data)
                          : null
                      "
                    >
                    </app-base-dropdown>
                  </ng-container>
                  <ng-container *ngIf="!editInline">
                    <p-dropdown
                      *ngIf="!editInline"
                      class="dropdown-item"
                      appendTo="body"
                      [disabled]="$any(item).disabled"
                      [options]="$any(item).options"
                      [(ngModel)]="data[item.dataField]"
                      (onChange)="
                        $any(item).onSelected
                          ? $any(item).onSelected($event.value, rowIndex, data)
                          : null
                      "
                    >
                    </p-dropdown>
                  </ng-container>
                </div>
                <div
                  *ngSwitchCase="COLUMN_TYPE.Status"
                  [class]="getStatusClassWrapper(item, data) + ' flex'"
                >
                  <div
                    class="max-w-10rem min-w-max w-full status-badge flex justify-content-center border-round-3xl text-sm border-1 border-round p-1 align-content-center {{
                      getStatusColorStyle(data, item.dataField ?? '', item)
                    }}"
                  >
                    <span
                      tooltipPosition="top"
                      [pTooltip]="
                        getStatusLabel(
                          getDataByPath(data, item.dataField || ''),
                          item
                        ) | translate
                      "
                      class="font-semibold text-center max-w-9rem p-1"
                      >{{
                        getStatusLabel(
                          getDataByPath(data, item.dataField || ''),
                          item
                        ) | translate
                      }}</span
                    >
                  </div>
                </div>
                <div *ngSwitchCase="COLUMN_TYPE.Percentage">
                  {{ getDataByPath(data, item.dataField || '') }}%
                </div>
                <div
                  *ngSwitchCase="COLUMN_TYPE.DataCode"
                  [className]="item.cssContainer"
                >
                  {{
                    getDataCodeLabel(
                      getDataByPath(data, item.dataField || ''),
                      item
                    ) | translate
                  }}
                </div>
                <div *ngSwitchCase="COLUMN_TYPE.DataListWithCount">
                  <div class="flex">
                    <div
                      [className]="item.cssContainer + ' mr-2'"
                      [pTooltip]="
                        (item.toolTip && item.toolTip(data)) ||
                        getDataDisplayWithCount(
                          data,
                          item.dataField || '',
                          $any(item).displayField,
                          item.separatorCharacter
                        ).toString()
                      "
                      tooltipPosition="top"
                    >
                      {{
                        getDataDisplayWithCount(
                          data,
                          item.dataField || '',
                          $any(item).displayField,
                          item.separatorCharacter
                        )
                      }}
                    </div>
                    <div class="ml-auto">
                      ({{ getDataByPath(data, item.dataField || '')?.length }})
                    </div>
                  </div>
                </div>
                <div *ngSwitchCase="COLUMN_TYPE.DataWithCountNo">
                  <div class="flex">
                    <div
                      [className]="item.cssContainer"
                      [pTooltip]="
                        (item.toolTip && item.toolTip(data)) ||
                        getDataDisplayWithCount(
                          data,
                          item.dataField || '',
                          $any(item).displayField
                        ).toString()
                      "
                      tooltipPosition="top"
                    >
                      {{ getDataByPath(data, item.dataField || '') }}
                    </div>
                    <div class="ml-auto white-space-nowrap">
                      ( {{ getDataByPath(data, $any(item).countNoField || '') }}
                      )
                    </div>
                  </div>
                </div>
                <div *ngSwitchCase="COLUMN_TYPE.DateFormat">
                  {{
                    dateFormat(getDataByPath(data, item.dataField || ''), item)
                  }}
                </div>

                <div *ngSwitchCase="COLUMN_TYPE.TextWithSub">
                  <span
                    tooltipPosition="top"
                    [pTooltip]="getDataByPath(data, item.dataField || '')"
                  >
                    <div
                      class="text overflow-hidden text-overflow-ellipsis"
                      [ngClass]="{
                        'cursor-pointer text-primary font-medium':
                          checkTextWithSubHaveOnClick(item),
                        'text-cell': !checkActionType(item.type)
                      }"
                    >
                      {{ getDataByPath(data, item.dataField || '') }}
                    </div>
                  </span>

                  <div class="sub-text" [class]="item.cssSubField">
                    <span
                      tooltipPosition="top"
                      [pTooltip]="
                        item.subDataConfig?.isDateTime
                          ? dateFormat(
                              getDataByPath(
                                data,
                                $any(item).subDataField || ''
                              ),
                              item.subDataConfig
                            )
                          : getDataByPath(data, $any(item).subDataField || '')
                      "
                    >
                      <div
                        *ngIf="!item.subColumnType"
                        class="overflow-hidden text-overflow-ellipsis"
                      >
                        {{
                          item.subDataConfig?.isDateTime
                            ? dateFormat(
                                getDataByPath(
                                  data,
                                  $any(item).subDataField || ''
                                ),
                                item.subDataConfig
                              )
                            : getDataByPath(data, $any(item).subDataField || '')
                        }}
                      </div>
                    </span>
                    <div
                      *ngIf="item.subColumnType === COLUMN_TYPE.DataCode"
                      [className]="item.cssContainer"
                    >
                      {{
                        getDataCodeLabelForSub(
                          getDataByPath(data, item.subDataField || ''),
                          item
                        ) | translate
                      }}
                    </div>
                    <div *ngIf="item.subColumnType === COLUMN_TYPE.Status">
                      <div
                        class="mt-2 max-w-10rem min-w-max w-full status-badge flex justify-content-center border-round-3xl text-sm border-1 border-round p-1 align-content-center {{
                          getStatusColorStyle(
                            data,
                            item.subDataField ?? '',
                            item,
                            true
                          )
                        }}"
                      >
                        <span
                          tooltipPosition="top"
                          [pTooltip]="
                            getStatusLabelSubField(
                              getDataByPath(data, item.subDataField || ''),
                              item
                            ) | translate
                          "
                          class="max-w-9rem"
                          >{{
                            getStatusLabelSubField(
                              getDataByPath(data, item.subDataField || ''),
                              item
                            ) | translate
                          }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngSwitchCase="COLUMN_TYPE.Number">
                  <div class="text" [class]="item.cssContainer">
                    {{
                      getDataByPath(data, item.dataField)
                        | number
                          : ($any(item).format ? $any(item).format : '1.2-2')
                    }}
                  </div>
                </div>
                <div *ngSwitchCase="COLUMN_TYPE.ListActionIcon" class="flex">
                  <div
                    *ngFor="let icon of $any(item).actionList"
                    class="mr-3 flex flex-column justify-content-center"
                  >
                    <i
                      [pTooltip]="icon.toolTip | translate"
                      class="{{ icon.icon }} cursor-pointer"
                      [ngStyle]="{
                        visibility: !(icon.onHide && icon.onHide(data))
                          ? 'unset'
                          : 'hidden'
                      }"
                      (click)="icon.onClick(data, rowIndex)"
                      *ngIf="
                        (icon.isHasPermission
                          ? icon.isHasPermission(data, rowIndex)
                          : true) && checkPermission(icon, data)
                      "
                    ></i>
                  </div>
                </div>
                <div *ngSwitchCase="COLUMN_TYPE.MoreAction">
                  <button
                    pButton
                    (click)="menu.toggle($event)"
                    pRipple
                    type="button"
                    icon="pi pi-ellipsis-h"
                    class="p-button-rounded p-button-text"
                  ></button>
                  <p-overlayPanel #menu [styleClass]="'folder-select-overlay'">
                    <div
                      [ngStyle]="{
                        padding: '8px',
                        cursor: (obj.disabled || obj.getDisabled?.(data)) ? 'not-allowed' : 'pointer'
                      }"
                      *ngFor="let obj of getMenuItem(item)"
                      (click)="!obj.disabled && obj.onClick(data, rowIndex)"
                    >
                      {{ obj.label | translate }}
                    </div>
                  </p-overlayPanel>
                </div>
                <div
                  *ngSwitchCase="COLUMN_TYPE.CustomCell"
                  [class]="$any(item).cellName"
                >
                  <ng-container
                    [ngTemplateOutlet]="getCustomCell($any(item))"
                    [ngTemplateOutletContext]="{ $implicit: data, rowIndex }"
                  >
                  </ng-container>
                </div>
                <div
                  [className]="item.cssContainer"
                  *ngSwitchDefault
                  [pTooltip]="
                    (item.toolTip && item.toolTip(data)) ||
                    getDataByPath(data, item.dataField || '', rowIndex)
                  "
                  tooltipPosition="top"
                >
                  {{ getDataByPath(data, item.dataField || '', rowIndex) }}
                </div>
              </div>
            </ng-template>
          </p-cellEditor>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr class="empty-state-container">
        <td [attr.colspan]="12">
          {{
            emptyDataMessage || 'There is no record(s) in the system.'
              | translate
          }}
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="paginatorleft">
      {{ currentEvent.first + 1 }} -
      {{
        dataTable.length < rows ||
        totalRecords < currentEvent.first + currentEvent.rowPerPage
          ? currentEvent.first + dataTable.length
          : currentEvent.first + currentEvent.rowPerPage
      }}
      of {{ totalRecords || dataTable.length }}
    </ng-template>
  </p-table>
</div>
